import React from 'react';
import aboutImg from '../../image/aboutUs_img.png'


const AboutUs = () => {
  return (
    <div className="responsive-section">
      <div className="content">
        <img
          src={aboutImg}
          alt="Example"
          className="content-image"
        />
        <div className="content-text">
          <h2>About Us</h2>
          <p>
          Puresight Systems Pvt. Ltd., established in 2014, specializes in providing innovative smart home appliances and accessories. With a focus on quality and customer satisfaction, the company delivers genuine products that enhance modern living across India.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
